<template>
  <div class="text-area-container">
    <template v-if="value">
      <button 
        type="button" 
        class="btn btn-link" 
        @mouseover.prevent="show" 
        @mouseleave.prevent="hide"
        @click.prevent="show">
        <i class="ti-align-justify"/>
      </button>

      <div 
        v-if="showText" 
        class="modalPanel" 
        @mouseover.prevent="show"
        @mouseleave.prevent="hide"
        @click.prevent="hide">
        <p>{{ value }}</p>
      </div>
      
    </template>
    <span v-else>---</span>
  </div>
</template>

<script>
// const debug = require('debug')('OD::BaseTableTextArea')

export default {
  name: 'BaseTableTextArea',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showText: false,
    }
  },
  methods: {
    show() {
      this.showText = true
    },
    hide() {
      this.showText = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modalPanel {
  max-width: 90%;
  max-height: calc(100% - 100px);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background-color: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 2px 2px 2px rgba(204, 197, 185, 0.5);

  p {
    margin: 20px;
    white-space: normal !important;
    display: block;
  }
}

.btn-link {
  border: 0;
}

@media (max-width: 991px) {
  .modalPanel {
    width: 100%;
    height: 80vh;
    top: unset;
  }
}
</style>
